<template>
<div>
    <div>
        <bossHeader/>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="storeType">
            <el-tab-pane v-for="(i,index) in 5" :key="index" :label="index == 0 ? '全部':(index == 1 ? '婷美摩力21':(index == 2 ?'臻幼堂':(index == 3 ? '槑博士婴幼儿草本浴':'臻月子')))" >
                <el-row class="storeAll" v-if="chooseData && chooseData.length > 0">
                    <el-col :span="6" class="store" v-for="(i,index) in chooseData" :key="index" @click.native="toStore(i)">
                        <el-row>
                            <el-col :span="10" class="logoTitle" v-if="i.brandId == 1">
                                <img src="../../assets/images/boss/tingmei.png">
                                <p>婷美摩力21</p>
                            </el-col>
                            <el-col :span="10" class="logoTitle" v-if="i.brandId == 2">
                                <img src="../../assets/images/boss/zhenyoutang.png">
                                <p>臻幼堂</p>
                            </el-col>
                            <el-col :span="10" class="logoTitle" v-if="i.brandId == 3">
                                <img src="../../assets/images/boss/meiboshi.png">
                                <p>槑博士草本养护</p>
                            </el-col>
                            <el-col :span="10" class="logoTitle" v-if="i.brandId == 4">
                                <img src="../../assets/images/boss/zhenyuezi.png">
                                <p>臻月子</p>
                            </el-col>
                            <el-col :span="14" class="cont">
                                <el-tooltip class="item" effect="dark" :content="i.storeName" placement="bottom" v-if="i.storeName && i.storeName.length > 8">
                                    <h5>{{i.storeName && i.storeName.length > 8 ? i.storeName.substr(0,8)+'...':i.storeName}}</h5>
                                </el-tooltip>
                                <h5 v-else>{{i.storeName && i.storeName.length > 8 ? i.storeName.substr(0,8)+'...':i.storeName}}</h5>
                                <p>店长：{{i.leader}}</p>
                                <p>电话：{{i.leaderPhone}}</p>
                                <p>地址：{{i.storeAddress}}</p>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <div class="nomesg" v-else>暂无门店信息</div>
            </el-tab-pane>
        </el-tabs>
        <Footer/>
    </div>
	<div>
	  <el-dialog title="温馨提示" :visible.sync="dialogVisibles" width="38%" center top="4%">
	    <div class="shopping-payON">
	      <b>尊敬的合作伙伴：</b>
	      <p>在系统正式运营的一年多的时间里，我们为了能够给合作伙伴们能够更好的提供服务，收集并汇总了各位合作伙伴提出的系统建设建议，特此对系统进行了大版本升级。具体功能升级如下：</p>
	      <p>1、开放所有商品的管理和维护权限，合作伙伴可自行添加维护商品，其中包含商品名称、价格等</p>
	      <p>2、去除原有模糊地带的公共套盒，用单次服务商品、整套服务商品替换，让库存不存在模糊地带</p>
	      <p>3、对库存管理进行了调整，单次服务商品、整套服务商品、零售商品区别化管理，增加了到货商品入库功能</p>
	      <p>4、新增套盒拆分单次</p>
	      <p>5、会员管理新增会员批量导入，方便合作伙伴切换系统批量上传</p>
	      <p>6、新增会员剩余服务余量管理，可对会员在门店剩余的服务进行调整</p>
	      <p>7、汇总了会员剩余服务、服务记录、购买记录</p>
	      <p>8、新增整套服务商品拆分单次服务商品</p>
        <p style="color: #f00;">特别说明：由于此版本更新范围较大，可能会存在问题</p>
	      <p>1、原有订单退货后库存无法退回，需要手动调整库存。</p>
	      <p>2、为了库存的精准，需要门店对库存精准盘点一次</p>
	      <p>3、大部分商品系统默认初始化，原来门店自己的体验券需要重新添加</p>
	    </div>
	    <div style="text-align: center;margin:20px auto;">
	      <el-button type="primary" class="shopping-set_sel-btn_s" plain @click="operaCanel">我知道了</el-button>
	    </div>
	  </el-dialog>
	</div>
</div>
</template>
<script>
import bossHeader from "@/components/common/bossHeader";
import Footer from "@/components/common/Footer";
import {selectStore, queryStaffVoice} from '@/api'

export default {
  components: {
    bossHeader,
    Footer
  },
    data(){
        return{
            activeName:'0',
            chooseData:this.$store.state.userInfo.storeList,
			      dialogVisibles:false
        }
    },
    beforeRouteEnter (to, from, next){
     next(vm => {    
       if (from.path == '/login/') {
         vm.dialogVisibles = true
       }
     })
    },
    activated () {
      this.chooseData = this.$store.state.userInfo.storeList
    },
    methods: {
     operaCanel (val) {
       this.dialogVisibles = false;
     },
        handleClick(tab, event) {
            this.chooseData = [];
            if(this.activeName != 0){
                for(let i of this.$store.state.userInfo.storeList){
                    if(i.brandId == this.activeName){
                        this.chooseData.push(i);
                    }
                }
            }else{
                this.chooseData = this.$store.state.userInfo.storeList
            }
        },
        toStore(info){
             localStorage.removeItem('user')
            // 进入门店系统
            selectStore({
                storeCode:info.storeCode
            }).then(res=>{
                if(res.code == 1){
                    let userInfo = Object.assign({},info);
                    userInfo.storeList = this.$store.state.userInfo.storeList
                    userInfo.staffName = this.$store.state.userInfo.staffName;
                    userInfo.staffId = this.$store.state.userInfo.staffId;
                    userInfo.redisKey = this.$store.state.userInfo.redisKey;
                    userInfo.staffPhone = this.$store.state.userInfo.staffPhone;
                    userInfo.bossId = info.bossId;

                    queryStaffVoice({
                      staffId:this.$store.state.userInfo.staffId
                    }).then(voiceres=>{
                      userInfo.setVoiceStatus = voiceres.data.isOpen;
                      if(voiceres.data.isOpen){
                        this.setVoiceMp3(true,voiceres.data.staffId);
                      }
                    })

                    this.$store.commit("updateUserInfo", userInfo);
                    this.$router.push("/operatingFloor");
                   localStorage.setItem('user', JSON.stringify(userInfo))

                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.shopping-payON b{color: #333;margin-bottom:12px;display:block;}
.shopping-payON p{color: #333;margin-bottom:12px; text-indent: 2em;}
.storeType{
    width: 1300px;
    margin: 25px auto;
}
.nomesg{
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
}
.storeAll{
    width: 1300px;
    margin: 0 auto;
    min-height: 650px;
    .store{
        width: 300px;
        height: 168px;
        background: #fff;
        border:1px solid rgba(213,217,227,1);
        border-radius:9px;
        margin:0 33px 28px 0;
        padding: 0 30px 0 0;
        cursor: pointer;
        &:nth-child(4n){
            margin-right:0;
        }
        .logoTitle{
            width: 120px;
            height: 100%;
            text-align: center;
            padding-top: 50px;
            img{
                width: 38px;
                height: auto;
                margin-bottom: 10px;
            }
        }
        .cont{
            width: 148px;
            height: 100%;
            color: #666;
            padding-top: 25px;
            h5{
                font-weight: bold;
                line-height: 30px;
            }
            p{
                font-size: 11px;
                line-height: 20px;
            }
        }
    }
}
</style>
<style lang="less">
.storeType{
    .el-tabs__item{
        color:#666;
    }
    .el-tabs__item:hover,.el-tabs__item.is-active{
        color:#6187FB;
        font-weight:bold;
    }
    .el-tabs__nav-wrap::after,.el-tabs__active-bar{
        display: none
    }
}
</style>



// WEBPACK FOOTER //
// src/components/bossCenter/allStore.vue